import { CloseCircleOutlined } from '@ant-design/icons';
import { Button } from '@mm/components';
import { Dialog } from '@mm/components/src/Dialog/Dialog';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import classNames from 'classnames';
import React, { FunctionComponent, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { BotBuilderRoutes } from '../../../../../../routes/bot-builder-routes';
import { ChannelIcon } from '../../../../liveChat/components/ChannelIcon';
import styles from './AutomationChannelButton.module.css';

interface Props {
  channel: 'email' | 'sms';
  onClick: () => void;
  enableSwitchChannelButton?: boolean;
  disabled?: boolean;
}

const LABELS: Record<Props['channel'], string> = {
  sms: 'SMS',
  email: 'Email',
};

export const AutomationChannelButton: FunctionComponent<Props> = ({
  onClick,
  enableSwitchChannelButton,
  channel,
  disabled,
}) => {
  const chatbotId = useSelector(activeChatbotIdSelector);
  const history = useHistory();

  const [showSwitchChannel, setShowSwitchChannel] = useState(false);
  const onClickSwitchChannel = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowSwitchChannel(s => !s);
  };
  const onCreateNewAutomation = () => {
    history.push(BotBuilderRoutes.automationNew.getLink({ chatbotId }));
  };

  const buttonClassname = classNames(styles.channel, {
    [styles.channelDisabled]: disabled,
  });

  return (
    <>
      <button className={buttonClassname} onClick={onClick} disabled={disabled}>
        <ChannelIcon className={styles.channelIcon} channel={channel} />
        {LABELS[channel]}
        {enableSwitchChannelButton && (
          <CloseCircleOutlined
            className={styles.switchChannelButton}
            onClick={onClickSwitchChannel}
          />
        )}
      </button>
      {disabled && (
        <div className={styles.contactText}>
          Contact support at{' '}
          <a href="mailto:support@customers.ai" target="_blank">
            support@customers.ai
          </a>{' '}
          to enable this channel
        </div>
      )}
      {showSwitchChannel && (
        <Dialog
          className={styles.switchChannelDialog}
          icon="warning"
          title="Do you want to switch Email and SMS channels?"
          buttons={
            <>
              <Button
                color="transparent-no-shadow"
                onClick={() => setShowSwitchChannel(false)}
              >
                Cancel
              </Button>
              <Button color="blue" onClick={onCreateNewAutomation}>
                Create a New Automation
              </Button>
            </>
          }
        >
          In order to save your current automation’s data create a new
          automation to use SMS channel
        </Dialog>
      )}
    </>
  );
};
